import {Loader, google as Google} from 'google-maps';

/**
 * @type {Promise}
 */
let loading = null;

/**
 * @type {Google}
 */
let google = null;

export default async function init_map() {
    const elements = Array.from(document.querySelectorAll('.map'));

    if ('IntersectionObserver' in window) {
        init_intersection(elements);
    } else {
        init_immediate(elements);
    }
}

function init_immediate(elements) {
    elements.forEach(create_map);
}

function init_intersection(elements) {
    const observer = new IntersectionObserver(on_intersection, {
        threshold: 0,
        rootMargin: '10%'
    });

    for (const element of elements) {
        observer.observe(element);
    }
}

function on_intersection(entries, observer) {
    for (const {isIntersecting, target} of entries) {
        if (isIntersecting) {
            console.log('IntersectionObserver', isIntersecting, target);

            create_map(target);

            observer.unobserve(target);
        }
    }
}

async function load_maps() {
    if (loading) {
        return await loading;
    } else if (google) {
        return google;
    }

    const loader = new Loader(window._APP_MAPS_API_KEY);

    loading = loader.load();

    return google = await loading;
}

async function create_map(element) {
    const google = await load_maps();
    const coord = attr => parseFloat(element.getAttribute('data-' + attr));

    const position = {lat: coord('lat'), lng: coord('lng')};

    const map = new google.maps.Map(element, {
        center: position,
        zoom: 16,
        mapTypeControl: false,
        streetViewControl: false,
        styles: THEME,
        gestureHandling: 'cooperative'
    });

    new google.maps.Marker({
        position,
        map,
        icon: {
            url: _APP_ROOT_URL + 'site/templates/images/brand/map-icon.png',
            scaledSize: new google.maps.Size(48, 48)
        }
    });
}

const THEME = [
    {
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "elementType": "labels.icon",
        "stylers": [
            {
                "visibility": "off"
            }
        ]
    },
    {
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "elementType": "labels.text.stroke",
        "stylers": [
            {
                "color": "#f5f5f5"
            }
        ]
    },
    {
        "featureType": "administrative.land_parcel",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#bdbdbd"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "poi",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "poi.park",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "road",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#ffffff"
            }
        ]
    },
    {
        "featureType": "road.arterial",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#757575"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#dadada"
            }
        ]
    },
    {
        "featureType": "road.highway",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#616161"
            }
        ]
    },
    {
        "featureType": "road.local",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    },
    {
        "featureType": "transit.line",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#e5e5e5"
            }
        ]
    },
    {
        "featureType": "transit.station",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#eeeeee"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "geometry",
        "stylers": [
            {
                "color": "#c9c9c9"
            }
        ]
    },
    {
        "featureType": "water",
        "elementType": "labels.text.fill",
        "stylers": [
            {
                "color": "#9e9e9e"
            }
        ]
    }
];